<template>
	<div>
		<b-button class="filter" variant="light" block href="#" v-b-toggle.accordion-filter>
			<span><b-icon-funnel-fill></b-icon-funnel-fill> Filter</span>
			<span class="menu-arrow">
				<b-icon-chevron-right class="float-right chevron-right"></b-icon-chevron-right><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
			</span>
		</b-button>
		<b-collapse id="accordion-filter" accordion="accordion-filter" role="tabpanel" class="menu-accordion">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-approval-tag" label-cols-sm="4" label-cols-lg="3" label="Approval Tag" label-for="filter-approval-tag" size="sm" :model.sync="filter.approvalTag" />
					<app-input-combobox-autocomplete :options="approvalConfigurations" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Configuration" id="filter-" size="sm" :model.sync="filter.approvalConfigurationId" @input="getApprovalConfigurations" @focus="getApprovalConfigurations" />
					<app-input-combobox-autocomplete :options="approvalTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Type" id="filter-" size="sm" :model.sync="filter.approvalTypeId" @input="getApprovalTypes" @focus="getApprovalTypes" />
					<app-input-combobox-autocomplete :options="approvalStates" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval State" id="filter-" size="sm" :model.sync="filter.approvalStateId" @input="getApprovalStates" @focus="getApprovalStates" />
					<app-input-textbox id="fieldset-document-id" label-cols-sm="4" label-cols-lg="3" label="Document Id" label-for="filter-document-id" size="sm" :model.sync="filter.documentId" />
					<app-input-textbox id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status" label-for="filter-status" size="sm" :model.sync="filter.status" />
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Originator" id="filter-" size="sm" :model.sync="filter.originatorId" @input="getUserInfos" @focus="getUserInfos" />
					<app-input-combobox-autocomplete :options="approvalStructures" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Structure" id="filter-" size="sm" :model.sync="filter.approvalStructureId" @input="getApprovalStructures" @focus="getApprovalStructures" />
					<b-button variant="danger" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" size="sm" class="float-right mr-1" @click="getApprovalInstances"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
		</b-collapse>
		<b-row class="mt-3">
			<b-col>
				<!-- <b-button variant="warning" v-if="(userRole != null ? userRole.allowUpdate : false)" class="float-right ml-2" @click="showPopupUploadData" size="sm"><b-icon-upload class="mr-1"></b-icon-upload> Upload</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDownload : false)"
					:show="isDownloadDataBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</b-overlay>
				<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right" :href="`files/ApprovalInstance/ApprovalInstance.xlsx`" size="sm"><b-icon-wallet-fill class="mr-1"></b-icon-wallet-fill> Download Template</b-button> -->
			</b-col>
		 </b-row>
		<b-card class="mt-3">
		<b-row class="mb-3">
			<b-col>
				<!-- <b-overlay
					v-if="(userRole != null ? userRole.allowCreate : false)"
					:show="isCreateBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" @click="createData" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				</b-overlay>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay> -->
			</b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<div class="table-corner">
			<b-table id="my-table" stacked="md" head-variant="head-light"  :no-local-sorting="true" :items="approvalInstances" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive>
			<template v-slot:head(actions)>
				<b-button-group class="float-right"  size="sm">
					<b-button @click="isShowFilter = !isShowFilter" size="sm"><b-icon-funnel-fill /></b-button>
					<!-- <b-button><b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right" v-model="selectAll"></b-form-checkbox></b-button> -->
				</b-button-group>
			</template>
			<template #top-row v-if="isShowFilter">
				<b-th></b-th>
				<!-- <b-th stacked-heading="Approval Tag">
					<b-form-input id="input-approval-tag-table" @input="getApprovalInstancesWithoutLoading" v-model="filter.approvalTag" size="sm"></b-form-input>
				</b-th> -->
				<b-th stacked-heading="Approval Configuration">
					<v-select append-to-body label="name" :options="approvalConfigurations" :value="filter.approvalConfigurationId" :reduce="item => item.id" v-model="filter.approvalConfigurationId" :filterable="true" @input="getApprovalInstancesWithoutLoading" @search="getApprovalConfigurations"></v-select>
				</b-th>
				<b-th stacked-heading="Document Id">
					<b-form-input id="input-document-id-table" @input="getApprovalInstancesWithoutLoading" v-model="filter.documentId" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approval Type">
					<v-select append-to-body label="name" :options="approvalTypes" :value="filter.approvalTypeId" :reduce="item => item.id" v-model="filter.approvalTypeId" :filterable="true" @input="getApprovalInstancesWithoutLoading" @search="getApprovalTypes"></v-select>
				</b-th>
				<b-th stacked-heading="Current Approver Sequence">
					<b-form-input id="input-current-approver-sequence-table" @input="getApprovalInstancesWithoutLoading" v-model="filter.currentApproverSequence" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Originator">
					<v-select append-to-body label="firstName" :options="userInfos" :value="filter.originatorId" :reduce="item => item.id" v-model="filter.originatorId" :filterable="true" @input="getApprovalInstancesWithoutLoading" @search="getUserInfos"></v-select>
				</b-th>
				<b-th stacked-heading="Approval State">
					<v-select append-to-body label="name" :options="approvalStates" :value="filter.approvalStateId" :reduce="item => item.id" v-model="filter.approvalStateId" :filterable="true" @input="getApprovalInstancesWithoutLoading" @search="getApprovalStates"></v-select>
				</b-th>
				<b-th stacked-heading="Status">
					<b-form-input id="input-status-table" @input="getApprovalInstancesWithoutLoading" v-model="filter.status" size="sm"></b-form-input>
				</b-th>
				<!-- <b-th stacked-heading="Approval Configuration Instance">
					<v-select append-to-body label="name" :options="approvalConfigurationInstances" :value="filter.approvalConfigurationInstanceId" :reduce="item => item.id" v-model="filter.approvalConfigurationInstanceId" :filterable="true" @input="getApprovalInstancesWithoutLoading" @search="getApprovalConfigurationInstances"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Structure">
					<v-select append-to-body label="name" :options="approvalStructures" :value="filter.approvalStructureId" :reduce="item => item.id" v-model="filter.approvalStructureId" :filterable="true" @input="getApprovalInstancesWithoutLoading" @search="getApprovalStructures"></v-select>
				</b-th> -->
				<b-th stacked-heading="Select All">
					<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
				</b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
			</template>
			<template v-slot:cell(approvalConfiguration)="row">
				{{ row.item.approvalConfiguration != null ? row.item.approvalConfiguration.name : "" }}
			</template>
			<template v-slot:cell(approvalConfigurationInstance)="row">
				{{ row.item.approvalConfigurationInstance != null ? row.item.approvalConfigurationInstance.name : "" }}
			</template>
			<template v-slot:cell(approvalType)="row">
				{{ row.item.approvalType != null ? row.item.approvalType.name : "" }}
			</template>
			<template v-slot:cell(approvalState)="row">
				{{ row.item.approvalState != null ? row.item.approvalState.name : "" }}
			</template>
			<!-- <template v-slot:cell(originator)="row">
				{{ row.item.originator != null ? row.item.originator.firstName + " | " + row.item.originator.lastName : "" }}
				{{ row.item != null ? row.item.originatorUserName }}
			</template> -->
			<template v-slot:cell(approvalStructure)="row">
				{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
			</template>
			<template v-slot:cell(actions)="row" >
				<div class="div-actions float-right">
				<!-- <b-button size="sm" v-if="(userRole != null ? userRole.allowUpdate : false)" @click="editData(row.index, row.item.id)" variant ="success"  class="mr-2 btn-xs">
					<b-icon-pencil></b-icon-pencil>
				</b-button> -->
				<!-- <b-overlay
					v-if="(userRole != null ? userRole.allowDelete : false)"
					:show="busy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<click-confirm>
					<b-button size="sm" variant="danger" @click="deleteData(row.item.id)" class="mr-2 btn-xs">
						<b-icon-trash></b-icon-trash>
					</b-button>
					</click-confirm>
				</b-overlay> -->
				<b-button size="sm" v-if="(userRole != null ? userRole.allowRead : false)" variant="primary" class="mr-2 mt-md-2 mt-lg-0 btn-xs" :to="{path: '/approvalinstance/detail/' + row.item.id }" >
					<b-icon-eye-fill></b-icon-eye-fill>
				</b-button>
				<!-- <b-button size="sm" v-if="(userRole != null ? userRole.allowPrint : false)" variant="light"  @click="printSingleData(row.item.id)" class="mr-2 mt-md-2 mt-lg-0 btn-xs">
					<b-icon-printer-fill></b-icon-printer-fill>
				</b-button>
				<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" class="d-inline" :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))" ></b-form-checkbox> -->
				</div>
			</template>
			</b-table>
		</div>
		<b-row>
			<b-col cols="12" md="6" lg="6">
				<!-- <b-overlay
					v-if="(userRole != null ? userRole.allowCreate : false)"
					:show="isCreateBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" @click="createData" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				</b-overlay>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay> -->
			</b-col>
			<b-col cols="12" md="6" lg="6">
			<b-pagination
				class="float-md-right btn-paging"
				v-model="currentPage"
				:total-rows="(approvalInstancesPaging != null ? approvalInstancesPaging.dataCount : 0)"
				:per-page="(approvalInstancesPaging != null ? approvalInstancesPaging.pageSize : 0)"
				aria-controls="my-table"
			></b-pagination>
			</b-col>
		</b-row>
		</b-card>
		<Upload
		:openPopup="showPopupUpload"
		@resetMethod="resetModalUpload"
		@uploadButtonMethod="uploadData"
		/>
		<PopupDownload
		:openPopup="showPopupDownload"
		:processId="processId"
		@resetModalMethod="resetModal"
		label= "Popup Download"
		:contentLabel = "popupDownloadLabel"
		/>
		<PopupPDF
		:openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label= "Popup PDF"
		/>
		
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
</style>
<script>
import ApprovalInstance from '@/models/ApprovalInstance/ApprovalInstance';
import ApprovalInstanceList from '@/models/ApprovalInstance/ApprovalInstanceList';
import ApprovalInstanceFilter from '@/filters/ApprovalInstance/ApprovalInstanceFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputTextarea from '@/components/AppInputTextarea';
import ApprovalConfigurationFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationFilter';
import ApprovalConfiguration from '@/models/ApprovalConfiguration/ApprovalConfiguration';
import ApprovalConfigurationInstanceFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceFilter';
import ApprovalConfigurationInstance from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstance';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import ApprovalType from '@/models/ApprovalType/ApprovalType';
import ApprovalStateFilter from '@/filters/ApprovalState/ApprovalStateFilter';
import ApprovalState from '@/models/ApprovalState/ApprovalState';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ActivityStateFilter from '@/filters/ActivityState/ActivityStateFilter';
import ActivityState from '@/models/ActivityState/ActivityState';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {ApprovalInstance, ApprovalInstanceList, ApprovalInstanceFilter, AppInputTextbox,AppInputTextarea,AppInputComboboxAutocomplete,PopupDownload,PopupPDF,Upload,PopupDataEditNotification,},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : { "class" : "th-number"}}, 
				// {"approvalTag": {}, "class" : "th-approval-tag", "label" : "Approval Tag", key: 'approvalTag', sortable: true}, 
				{"approvalConfiguration": {}, "class" : "th-approval-configuration text-center", "label" : "Approval Configuration", key: 'approvalConfiguration', sortable: true}, 
				{"documentId": {}, "class" : "th-document-id text-center", "label" : "Document Id", key: 'documentId', sortable: true}, 
				{"approvalType": {}, "class" : "th-approval-type text-center", "label" : "Approval Type", key: 'approvalType', sortable: true}, 
				{"currentApproverSequence": {}, "class" : "th-current-approver-sequence text-center", "label" : "Current Approver", key: 'currentApproverSequence', sortable: true}, 
				{"originator": {}, "class" : "th-originator text-center", "label" : "Originator", key: 'originatorId', sortable: true}, 
				//{"originator": {}, "class" : "th-originator text-center", "label" : "Originator", key: 'createdBy', sortable: true}, 
				{"approvalState": {}, "class" : "th-approval-state text-center", "label" : "Approval State", key: 'approvalState', sortable: true}, 
				{"status": {}, "class" : "th-status text-center", "label" : "Status", key: 'status', sortable: true}, 
				// {"approvalConfigurationInstance": {}, "class" : "th-approval-configuration-instance", "label" : "Approval Configuration Instance", key: 'approvalConfigurationInstance', sortable: true}, 
				// {"approvalStructure": {}, "class" : "th-approval-structure", "label" : "Approval Structure", key: 'approvalStructure', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			approvalInstances: [],
			approvalInstancesPaging: {},
			approvalConfigurations : [],
			approvalConfigurationInstances : [],
			approvalTypes : [],
			approvalStates : [],
			userInfos : [],
			approvalStructures : [],
		}
	},
	methods : {
		getApprovalInstances : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ApprovalInstance.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.approvalInstances = result.data
					this.approvalInstancesPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getApprovalInstancesWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ApprovalInstance.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.approvalInstances = result.data
					this.approvalInstancesPaging = result
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurations : async function(input) {
			let filter = new ApprovalConfigurationFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalConfiguration.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurations = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurationInstances : async function(input) {
			let filter = new ApprovalConfigurationInstanceFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalConfigurationInstance.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstances = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalTypes : async function(input) {
			let filter = new ApprovalTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStates : async function(input) {
			let filter = new ApprovalStateFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalState.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStates = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new ApprovalInstanceFilter();
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getApprovalInstances();
		},
		toggleIsPrint(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ApprovalInstance.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ApprovalInstance.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			ApprovalInstance.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		createData() {
			this.isCreateBusy = true;
			ApprovalInstance.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'approvalinstanceedit', params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			ApprovalInstance.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'approvalinstanceedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},
		deleteData(id) {
			ApprovalInstance.deleteData(this, id).then(result => {
				if (result)
				{
					this.getApprovalInstances();
				}
			})
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ApprovalInstanceFilter();
		this.getApprovalConfigurations()
		this.getApprovalConfigurationInstances()
		this.getApprovalTypes()
		this.getApprovalStates()
		this.getUserInfos()
		this.getApprovalStructures()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Approval Instance"
		];
		this.getApprovalInstances();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getApprovalInstances();
			}
		},
		sortDesc: {
			handler: function() {
				this.getApprovalInstances();
			}
		},
		currentPage: {
			handler: function() {
				this.getApprovalInstances();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getApprovalInstances();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ApprovalInstance.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "approvalinstanceindex") {
					this.getApprovalInstancesWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "approval_instance").first();
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
